__turbopack_context__.v({
  "section": "NDvjIq_section",
});
